module.exports = __webpack_public_path__ + "static/media/Bear.8e682fa6.png";